"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowMeter = void 0;
const datamodel_core_1 = require("@iotv/datamodel-core");
const typeName = 'FlowMeter';
class FlowMeter extends datamodel_core_1.DeviceEnabledType {
    constructor(ob) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        super(ob.type || typeName, ob);
        this.purposeType = (_a = ob.purposeType) !== null && _a !== void 0 ? _a : '';
        // this.meterType = ob.meterType
        // this.diameter = ob.diameter
        this.maximumFlowRate = (_c = (_b = ob.maximumFlowRate) !== null && _b !== void 0 ? _b : ob.maxrate) !== null && _c !== void 0 ? _c : null;
        this.setFlowRate = (_d = ob.setFlowRate) !== null && _d !== void 0 ? _d : null;
        this.flow = (_e = ob.flow) !== null && _e !== void 0 ? _e : null;
        this.location = (_f = ob.location) !== null && _f !== void 0 ? _f : ob.position;
        this.pulseCounterFrequency = (_g = ob.pulseCounterFrequency) !== null && _g !== void 0 ? _g : null;
        this.pulseCountCalibration = (_h = ob.pulseCountCalibration) !== null && _h !== void 0 ? _h : null;
        this.image = (_j = ob.image) !== null && _j !== void 0 ? _j : null;
        this.flowPerPulse = (_l = (_k = ob.flowPerPulse) !== null && _k !== void 0 ? _k : ob.flowperpulse) !== null && _l !== void 0 ? _l : null;
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            name: {
                type: 'String',
                editable: true,
                label: 'Name',
                name: 'name',
                description: 'Name of Water Flow Meter',
            },
            purposeType: {
                type: 'String',
                editable: true,
                label: 'Purpose/ Type',
                name: 'purpose/Type',
                description: 'Purpose/ type of Flow',
            },
            meterType: {
                type: 'String',
                editable: true,
                label: 'Meter Type',
                name: 'meterType',
                description: 'Meter type',
            },
            diameter: {
                type: 'Number',
                editable: true,
                label: 'Diameter',
                name: 'diameter',
                description: 'Diameter of Water Flow pipe - mm',
            },
            maximumFlowRate: {
                type: 'Number',
                editable: true,
                label: 'Maximum Flow Rate (L/m)',
                name: 'maximumFlowRate',
                description: 'Maximum flow rate ',
            },
            // setFlowRate: {
            //   type: "Number",
            //   editable: true,
            //   label: "Set Flow Rate",
            //   name: "setFlowRate",
            //   description: "Flow rate set for the Water Flow",
            // },
            // flow: {
            //   type: "Number",
            //   editable: true,
            //   label: "Flow",
            //   name: "flow",
            //   description: "Water flow  litres/ sec and cubic metres/ sec",
            // },
            location: {
                type: 'object',
                editable: true,
                label: 'Location',
                name: 'location',
                description: 'Location of  Water Flow Meter (lat/ long)',
            },
            // pulseCounterFrequency: {
            //   type: "Number",
            //   editable: true,
            //   label: "Pulse counter frequency",
            //   name: "pulseCounterFrequency",
            //   description: "Frequency of pulse counts from meter to measure flow",
            // },
            pulseFlowAmount: {
                type: 'Number',
                editable: true,
                label: 'Flow (Liters) per pulse',
                name: 'pulseFlowAmount',
                description: 'Flow per pulse to calculate water flow',
            },
            // pulseCountCalibration: {
            //   type: "Number",
            //   editable: true,
            //   label: "Pulse Count Calibration",
            //   name: "pulseCountCalibration",
            //   description: "Calibration of pulse counts to calculate water flow",
            // },
            image: {
                type: 'String',
                editable: true,
                label: 'Image',
                name: 'image',
                description: 'Photograph of Water Flow meter',
            },
            comments: {
                type: 'String',
                editable: true,
                label: 'Comments',
                name: 'comments',
                description: 'Free text for info ',
            },
        };
    }
}
exports.FlowMeter = FlowMeter;
